import { render, staticRenderFns } from "./TemplateManual.vue?vue&type=template&id=52eca998"
import script from "./TemplateManual.vue?vue&type=script&lang=js"
export * from "./TemplateManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports